import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <footer className="bg-gray-850 text-white">
        <div className="container-width py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
        {/* Company Info */}
        <div className="col-span-1 md:col-span-2">
        <h3 className="text-2xl font-normal mb-4">
        The Migration<span className="text-red-600">Experts</span>
        </h3>
        <p className="text-gray-400 mb-4">
        Expert cloud tenant-to-tenant migration services.
        Zero downtime, maximum security, complete peace of mind.
        </p>
        </div>

        {/* Quick Links */}
        <div>
        <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
        <ul className="space-y-2">
        <li>
        <Link to="/services" className="text-gray-400 hover:text-white transition-colors">
        Our Services
        </Link>
        </li>
        <li>
        <Link to="/about" className="text-gray-400 hover:text-white transition-colors">
        About Us
        </Link>
        </li>
        <li>
        <Link to="/contact" className="text-gray-400 hover:text-white transition-colors">
        Contact
        </Link>
        </li>
        </ul>
        </div>

        {/* Contact Info */}
        <div>
        <h4 className="text-lg font-semibold mb-4">Get in Touch</h4>
        <ul className="space-y-2 text-gray-400">
        <li>Email: info@themigrationexperts.com</li>
        <li>Phone: 1-800-MIGRATE</li>
        </ul>
        </div>
        </div>

        <div className="mt-8 pt-8 border-t border-gray-700 text-center text-gray-400">
        <p>&copy; {new Date().getFullYear()} The Migration Experts. All rights reserved.</p>
        </div>
        </div>
        </footer>
    );
};

export default Footer;
